import { render, staticRenderFns } from "./PriorityTypeCategoryTotals.vue?vue&type=template&id=66e118cc&scoped=true&"
import script from "./PriorityTypeCategoryTotals.vue?vue&type=script&lang=js&"
export * from "./PriorityTypeCategoryTotals.vue?vue&type=script&lang=js&"
import style0 from "./PriorityTypeCategoryTotals.vue?vue&type=style&index=0&id=66e118cc&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e118cc",
  null
  
)

export default component.exports